/* 商品一覧の絞り込み・並び替え（サーバーが出力したカードをブラウザ内で表示切替）。
   URL: ?category=shampoo,daily&concern=paw&sort=price-asc （category=all または未指定＝絞り込みなし） */
(function () {
  'use strict';
  const root = document.querySelector('[data-catalog]');
  if (!root) return;
  const CATEGORY = ['shampoo', 'daily', 'tools', 'set', 'refill'];
  const CONCERN = ['wash', 'dry', 'coat', 'paw', 'brush', 'lather'];
  const SORTS = ['recommended', 'price-asc', 'price-desc'];
  const grid = document.getElementById('product-list');
  const empty = document.getElementById('cat-empty');
  const count = document.getElementById('cat-count');
  const sortSel = document.getElementById('cat-sort');
  const side = document.getElementById('cat-side');
  const toggle = document.getElementById('cat-toggle');
  const cards = [...grid.querySelectorAll('.cat-card')];
  const state = { cat: new Set(), concern: new Set(), sort: 'recommended' };

  const lang = () => (window.TEGSUMI ? window.TEGSUMI.lang() : 'ja');
  const countText = (n) => ({ ja: `${n} 商品`, en: `${n} ${n === 1 ? 'product' : 'products'}`, ko: `${n}개 상품`, zh: `${n}件商品` }[lang()] || `${n}`);
  const list = (s) => (s || '').split(',').map((x) => x.trim()).filter(Boolean);

  function readUrl() {
    const q = new URLSearchParams(location.search);
    state.cat = new Set(list(q.get('category')).filter((k) => CATEGORY.includes(k)));
    state.concern = new Set(list(q.get('concern')).filter((k) => CONCERN.includes(k)));
    const s = q.get('sort');
    state.sort = SORTS.includes(s) ? s : 'recommended';
  }
  function writeUrl() {
    try {
      const u = new URL(location.href);
      const set = (k, v) => (v ? u.searchParams.set(k, v) : u.searchParams.delete(k));
      set('category', [...state.cat].join(','));
      set('concern', [...state.concern].join(','));
      set('sort', state.sort === 'recommended' ? '' : state.sort);
      history.replaceState(null, '', u);
    } catch (e) { /* URL を書き換えられない環境では無視 */ }
  }
  const matches = (card) => {
    const cats = list(card.dataset.categories);
    const cons = list(card.dataset.concerns);
    return (!state.cat.size || cats.some((c) => state.cat.has(c))) && (!state.concern.size || cons.some((c) => state.concern.has(c)));
  };

  function apply() {
    const shown = cards.filter(matches);
    const order = [...shown];
    if (state.sort === 'price-asc') order.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
    else if (state.sort === 'price-desc') order.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
    else order.sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order));
    cards.forEach((c) => (c.hidden = !shown.includes(c)));
    order.forEach((c) => grid.insertBefore(c, empty));
    empty.hidden = shown.length > 0;
    count.textContent = countText(shown.length);
    const any = state.cat.size || state.concern.size;
    side.querySelectorAll('.cat-clear').forEach((b) => (b.hidden = !any));
    side.querySelectorAll('input[type=checkbox]').forEach((i) => (i.checked = (i.dataset.cat === 'cat' ? state.cat : state.concern).has(i.value)));
    sortSel.value = state.sort;
    writeUrl();
  }

  root.addEventListener('change', (e) => {
    const el = e.target;
    if (el.matches('.cat-side input[type=checkbox]')) {
      const set = el.dataset.cat === 'cat' ? state.cat : state.concern;
      el.checked ? set.add(el.value) : set.delete(el.value);
      apply();
    } else if (el === sortSel) {
      state.sort = sortSel.value;
      apply();
    }
  });
  root.addEventListener('click', (e) => {
    if (e.target.closest('#cat-toggle')) {
      const open = !side.classList.contains('open');
      side.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    const act = e.target.closest('button[data-cat]');
    if (!act) return;
    if (act.dataset.cat === 'clear') { state.cat.clear(); state.concern.clear(); apply(); }
    else if (act.dataset.cat === 'close') {
      side.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      root.querySelector('.cat-bar').scrollIntoView({ block: 'start' });
    }
  });

  readUrl();
  apply();
  document.addEventListener('tegsumi:ready', () => { count.textContent = countText(cards.filter(matches).length); });
})();
